/* R.A.F.E. — light custom behaviour for theme 203830886745 (draft).
   Desktop only: cycle a product card's images while the pointer rests on it (C3).
   nav-below-hero was removed in Stage 1 — superseded by the transparent
   floating header (A2/A6). Scoped, no dependencies, no app. */

/* R.A.F.E. :: BLOCK 28 -- hero height is a 16:9 band, not the viewport.

   The campaign film is 1920x1080. A full-height hero had to crop it to fill a tall
   phone viewport, so the hero is now width-derived: height = painted width * 9 / 16.

   This must run FIRST. Two later blocks in this file measure the hero with
   offsetHeight (the header-solidify trigger and the 1:1 overlay travel), and the CSS
   fallback calc(100vw * 9 / 16) is scrollbar-inclusive and therefore a few px tall on
   desktop. Setting the variable before those blocks parse means they measure the
   corrected height on their first pass and never have to be told about the ratio. */
(function () {
  'use strict';

  var RATIO_W = 16, RATIO_H = 9;
  var root = document.documentElement;

  /* BLOCK 29 item 2: the announcement bar is a layer ABOVE the hero, not a lid on it.
     --rafe-ann-h is declared 36px / 40px in CSS, but at 390 and 375 the shipping copy
     wraps to two lines and the bar is really 52px, so the declared value was 12px short:
     the bar covered 12px of film that the layout believed was clear, and the absolute
     header (positioned from the same var) overlapped the bar by 12px. Measure it rather
     than trust the constant. Clearing our own override first is what makes this stable --
     the var feeds the bar's own min-height, so measuring with it still applied would latch
     whatever we last wrote. Cleared, CSS falls back to 36/40 and the rect comes back as
     max(fallback, content), which is the number we actually want. */
  function setAnnVar() {
    var bar = document.querySelector('aside.announcement-bar');
    if (!bar) return 0;
    var prev = root.style.getPropertyValue('--rafe-ann-h');
    root.style.removeProperty('--rafe-ann-h');
    var h = Math.round(bar.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--rafe-ann-h', h + 'px');
    else if (prev) root.style.setProperty('--rafe-ann-h', prev);
    return h > 0 ? h : (parseFloat(prev) || 0);
  }

  function setHeroVar() {
    /* clientWidth, not innerWidth: the fixed .hero is width:100% of the initial
       containing block, which excludes a classic scrollbar. innerWidth would make
       the band ~8px too tall at 1440 and reintroduce a sliver of crop. */
    var w = root.clientWidth || window.innerWidth || 0;
    if (!w) return;

    var annH = setAnnVar();
    var h = w * RATIO_H / RATIO_W;

    /* Cap at the height actually available BELOW the bar. The hero is fixed and the page
       rides up over it, so scrolling COVERS the film rather than revealing it -- anything
       below the fold at rest is below the fold forever. Measured at 1440x780 the film's
       bottom edge sat at viewport y=810 at every scroll position and the most of it ever
       on screen was 780px, so the cap has to stay.
       BLOCK 29 item 1: the cap is ALSO what was cropping the film top and bottom. A capped
       band is no longer 16:9 -- at 1920x855 it measured 2.246 -- so object-fit: cover had
       real work to do and discarded 20.83% of the frame's height. The band stays capped,
       but the film is now object-fit: contain, so the shortfall shows as letterbox instead
       of as a crop. Subtracting annH is what keeps the band clear of the bar. */
    var vh = root.clientHeight || window.innerHeight || 0;
    if (vh) h = Math.min(h, vh - annH);
    if (h < 1) h = 1;

    root.style.setProperty('--rafe-hero-h', h.toFixed(2) + 'px');
  }

  setHeroVar();
  window.addEventListener('resize', setHeroVar, { passive: true });
  window.addEventListener('orientationchange', setHeroVar, { passive: true });
  window.addEventListener('pageshow', setHeroVar, { passive: true });
  window.addEventListener('load', setHeroVar);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeroVar);
  }
  /* the bar's wrap point moves when the body face swaps in, which changes its height */
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(setHeroVar);
  }
})();
(function () {
  'use strict';

  /* ---- hover cycling on product cards, desktop pointers only (C3) ---- */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var DELAY = 1100;
  function bindCard(gallery) {
    if (gallery.dataset.rafeCycle === 'on') return;
    gallery.dataset.rafeCycle = 'on';
    var timer = null;
    function slideshow() { return gallery.querySelector('slideshow-component'); }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      var s = slideshow();
      if (!s) return;
      try { if (typeof s.select === 'function') s.select(0); } catch (e) {}
      var scroller = s.querySelector('[ref="scroller"]');
      if (scroller) { try { scroller.scrollTo({ left: 0, behavior: 'auto' }); } catch (e) {} }
    }
    gallery.addEventListener('pointerenter', function (e) {
      if (!canHover.matches || e.pointerType !== 'mouse') return;
      var s = slideshow();
      if (!s || typeof s.next !== 'function') return;
      if (s.querySelectorAll('slideshow-slide, [slideshow-slide], li').length < 3) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () { try { s.next(); } catch (err) { clearInterval(timer); timer = null; } }, DELAY);
    });
    gallery.addEventListener('pointerleave', stop);
    gallery.addEventListener('focusout', stop);
  }
  function bindAll() {
    if (!canHover.matches) return;
    document.querySelectorAll('.card-gallery').forEach(bindCard);
  }

  function run() { try { bindAll(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:reorder', run);
  window.addEventListener('pageshow', run);
  var pending = null;
  function schedule() { if (pending) return; pending = setTimeout(function () { pending = null; run(); }, 120); }
  var main = document.querySelector('main');
  if (main) { new MutationObserver(schedule).observe(main, { childList: true, subtree: true }); }
})();


/* R.A.F.E. :: product card dots, and the add-to-cart path the card sizes use (Stage 3
   revised; the size row itself stopped being always-visible in block 23 and now lives behind
   the + - the add path below is unchanged) */
(function () {
  'use strict';

  function scrollerOf(gallery) {
    return gallery.querySelector('slideshow-slides');
  }

  function syncDots(gallery) {
    var wrap = gallery.querySelector('[data-rafe-dots]');
    var sc = scrollerOf(gallery);
    if (!wrap || !sc) return;
    var w = sc.clientWidth || 1;
    var i = Math.round(sc.scrollLeft / w);
    var dots = wrap.querySelectorAll('.rafe-dots__dot');
    if (i < 0) i = 0;
    if (i > dots.length - 1) i = dots.length - 1;
    for (var n = 0; n < dots.length; n++) {
      dots[n].classList.toggle('is-active', n === i);
    }
  }

  function bindDots(gallery) {
    if (gallery.__rafeDots) return;
    gallery.__rafeDots = true;
    var sc = scrollerOf(gallery);
    if (!sc) return;
    var raf = null;
    sc.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; syncDots(gallery); });
    }, { passive: true });
    var wrap = gallery.querySelector('[data-rafe-dots]');
    if (wrap) {
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rafe-dot]');
        if (!b) return;
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(b.getAttribute('data-rafe-dot'), 10) || 0;
        sc.scrollTo({ left: idx * sc.clientWidth, behavior: 'smooth' });
      });
    }
    syncDots(gallery);
  }

  /* one tap on a size adds it and opens the drawer */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rafe-qa-variant]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('[data-rafe-qa-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('[data-rafe-qa-id]');
    if (!input) return;
    input.value = btn.getAttribute('data-rafe-qa-variant');
    openCartDrawerOnce();
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
  });

  function openCartDrawerOnce() {
    var done = false;
    function handler() {
      if (done) return;
      done = true;
      document.removeEventListener('cart:update', handler);
      setTimeout(function () {
        var cd = document.querySelector('cart-drawer-component');
        if (cd && typeof cd.open === 'function' && !cd.querySelector('dialog[open]')) {
          try { cd.open(); } catch (err) {}
        }
      }, 80);
    }
    document.addEventListener('cart:update', handler);
    setTimeout(function () { document.removeEventListener('cart:update', handler); }, 6000);
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-rafe-qa-form]')) openCartDrawerOnce();
  }, true);

  function bindAll() {
    var gs = document.querySelectorAll('.card-gallery');
    for (var i = 0; i < gs.length; i++) bindDots(gs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  window.addEventListener('pageshow', bindAll);

  var pending = null;
  var main = document.querySelector('main');
  if (main) {
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; bindAll(); }, 120);
    }).observe(main, { childList: true, subtree: true });
  }
})();


/* R.A.F.E. :: the card + reveals the size strip (block 23, item 4).
   The + is the only new control. Everything behind it - the form, the variant id input, the
   click-to-add and the drawer open - is the mechanism the always-visible size row used, and it
   is untouched: this block only shows and hides the strip. Bound on document in the capture
   phase so the reveal happens before the card's own link handling can run. */
(function () {
  'use strict';

  function panelOf(qa) { return qa.querySelector('[data-rafe-qa-panel]'); }

  function close(qa) {
    if (!qa) return;
    var p = panelOf(qa);
    if (p) p.hidden = true;
    qa.classList.remove('is-open');
    var t = qa.querySelector('[data-rafe-qa-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    var open = document.querySelectorAll('[data-rafe-qa].is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) close(open[i]);
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var toggle = e.target.closest('[data-rafe-qa-toggle]');
    if (toggle) {
      var qa = toggle.closest('[data-rafe-qa]');
      var panel = qa && panelOf(qa);
      if (!panel) return;
      /* the + sits over the card's image, which is a link: neither must fire */
      e.preventDefault();
      e.stopPropagation();
      var willOpen = panel.hidden;
      closeAll(qa);
      panel.hidden = !willOpen;
      qa.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var first = panel.querySelector('[data-rafe-qa-variant]:not([disabled])');
        if (first) { try { first.focus({ preventScroll: true }); } catch (err) {} }
      }
      return;
    }
    /* a size was taken. The add handler above does the work; this only puts the strip away,
       and it waits a tick so the strip is still intact when that handler reads the event. */
    if (e.target.closest('[data-rafe-qa-variant]')) {
      setTimeout(function () { closeAll(null); }, 0);
      return;
    }

    /* anything else closes, including a tap on another card */
    if (!e.target.closest('[data-rafe-qa]')) closeAll(null);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-rafe-qa].is-open');
    if (!open) return;
    var toggle = open.querySelector('[data-rafe-qa-toggle]');
    close(open);
    if (toggle) { try { toggle.focus({ preventScroll: true }); } catch (err) {} }
  });

  /* a section re-render replaces the node, so there is nothing to re-bind - the listeners are
     on document and the state lives in the markup. Only a stale open flag needs clearing. */
  window.addEventListener('pageshow', function () { closeAll(null); });
})();

/* R.A.F.E. :: fixed hero + header solidify off hero (change 2, A3) */
(function () {
  'use strict';

  var first = document.querySelector('#MainContent > .shopify-section');
  var heroSection = first && first.classList.contains('hero-wrapper') ? first : null;
  var header = document.querySelector('header-component.header');
  if (!header || !heroSection) return;

  var heroH = heroSection.offsetHeight || window.innerHeight;

  function update() {
    var y = window.scrollY || window.pageYOffset || 0;
    header.classList.toggle('rafe-header-solid', y > heroH * 0.8);
    heroSection.classList.toggle('rafe-hero-past', y > heroH + 2);
  }

  function remeasure() {
    heroH = heroSection.offsetHeight || window.innerHeight;
    update();
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', remeasure, { passive: true });
  window.addEventListener('orientationchange', remeasure, { passive: true });
  window.addEventListener('pageshow', remeasure);
  /* removed: a copy-paste leftover from the hero-overlay IIFE below, which references
     lastP (a typo of its lastY) and apply(), neither of which exist in this closure.
     In strict mode it threw ReferenceError on every tab re-focus. The hero-overlay
     IIFE already registers its own correct visibilitychange handler, and this closure
     needs nothing on re-focus: update() is scroll-driven and scrollY cannot change
     while the tab is hidden, and pageshow -> remeasure() above covers bfcache restore. */
  update();
})();

/* R.A.F.E. :: an accordion row with nothing behind it never shows (D5, empty descriptions) */
(function () {
  'use strict';
  function prune() {
    var rows = document.querySelectorAll('.product-details .accordion accordion-custom');
    for (var i = 0; i < rows.length; i++) {
      var body = rows[i].querySelector('.details-content, .accordion__content');
      if (!body) continue;
      var real = body.querySelector('img, p, ul, ol, table, div, span:not([hidden])');
      var text = (body.textContent || '').trim().length > 0;
      rows[i].classList.toggle('rafe-row-empty', !real && !text);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prune);
  } else { prune(); }
  document.addEventListener('shopify:section:load', prune);
})();


/* R.A.F.E. :: BLOCK 29 item 3 -- the block 28 relocation module has been removed.

   Block 28 moved .hero__content-wrapper out of the fixed .hero into a generated
   .rafe-hero-caption below the film on mobile, because at 390 a 157.7px text block
   left nothing of a 219.4px band to look at. Reverted here on instruction: the text
   goes back over the film at every width, bottom-anchored, scaled to the band.

   Two things changed that make it fit now where it did not before. Item 2 took the
   announcement bar off the film, so the chrome standing over the band at 390 fell from
   84px to the header's 44px, and the type is scaled to the band (section 79 of
   rafe-overrides.css). Nothing replaces this block: the wrapper simply never leaves
   .hero, so the 1:1 overlay block below owns it unconditionally. That block's lazy
   resolve()/release() plumbing is deliberately kept -- it is inert when the node never
   moves, and it is what guarantees no inline transform can be stranded on it. */

/* R.A.F.E. :: the hero overlay travels with the page (block 12, item 2).
   translateY(-scrollY) at 1:1 for the length of the hero, so the gap between the
   text and the rising grid edge stays constant and the text leaves the top of the
   viewport exactly as normal content would. The fade only exists so it is gone
   before it would clip against the viewport edge. 1:1 travel is not parallax, so
   it runs for reduced-motion users too. */
(function () {
  'use strict';

  var sec = document.querySelector('#MainContent > .shopify-section.hero-wrapper:first-child');
  if (!sec) return;
  var hero = sec.querySelector('.hero');
  if (!hero) return;

  var heroH = 0, fadeStart = 0, fadeEnd = 1, lastY = -1, rafId = 0;

  /* BLOCK 28: this is only an overlay while it is inside the fixed .hero. Under
     option (b) the block above relocates it below the film on mobile, where it is
     ordinary in-flow content -- it travels 1:1 by definition and has nothing to fade
     against, so this block must stand down rather than keep driving transform and
     opacity on a node that has left. The lookup is scoped to .hero and re-resolved on
     every pass, so crossing the breakpoint in either direction is handled without
     this block caring which direction it was. */
  var wrap = null;

  function release(el) {
    if (!el) return;
    el.style.transform = '';
    el.style.opacity = '';
    el.style.visibility = '';
    el.style.pointerEvents = '';
    el.style.willChange = '';
  }

  function resolve() {
    var found = hero.querySelector('.hero__content-wrapper');
    if (found === wrap) return wrap;
    release(wrap);
    wrap = found;
    if (wrap) wrap.style.willChange = 'transform, opacity';
    lastY = -1;
    return wrap;
  }

  function measure() {
    heroH = hero.offsetHeight || sec.offsetHeight || window.innerHeight;
    if (!resolve()) return;

    var prev = wrap.style.transform;
    wrap.style.transform = 'none';

    heroH = hero.offsetHeight || sec.offsetHeight || window.innerHeight;

    var heroTop = hero.getBoundingClientRect().top;
    var kids = wrap.children;
    var topY = Infinity;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (!r.height) continue;
      var t = r.top - heroTop;
      if (t < topY) topY = t;
    }
    if (!isFinite(topY)) topY = heroH * 0.7;

    /* zero opacity just before the highest line of text would touch the top edge.
       BLOCK 28: in a 16:9 band the overlay sits near the top of a ~219px hero on a
       phone, so topY collapses to single digits and the 80px hard floor was left
       doing all the work -- the text blinked out inside 80px of scroll. The floor is
       now the larger of 80px and 45% of the hero, so the fade window stays in
       proportion to the band. Desktop is untouched: at 1440 topY * 0.92 is 641
       against a 364 floor, at 1920 it is 807 against 486. */
    fadeEnd = Math.max(80, Math.round(topY * 0.92), Math.round(heroH * 0.45));
    fadeStart = Math.round(fadeEnd * 0.45);

    wrap.style.transform = prev;
    lastY = -1;
    apply();
  }

  function apply() {
    if (!wrap || !hero.contains(wrap)) { release(wrap); wrap = null; return; }
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (y < 0) y = 0;
    if (y === lastY) return;
    lastY = y;

    var travel = y > heroH ? heroH : y;
    var o;
    if (y <= fadeStart) o = 1;
    else if (y >= fadeEnd) o = 0;
    else o = 1 - (y - fadeStart) / (fadeEnd - fadeStart);

    wrap.style.transform = 'translate3d(0,' + (-travel).toFixed(1) + 'px,0)';
    wrap.style.opacity = o.toFixed(3);
    /* once invisible the links must not stay clickable over the grid */
    wrap.style.visibility = o <= 0.001 ? 'hidden' : '';
    wrap.style.pointerEvents = o <= 0.001 ? 'none' : '';
  }

  /* cancel and reschedule rather than a boolean latch: a frame dropped by a
     backgrounded tab must not leave the latch stuck true */
  function onScroll() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(function () { rafId = 0; apply(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('orientationchange', measure, { passive: true });
  window.addEventListener('pageshow', measure, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
    lastY = -1;
    apply();
  });

  measure();
  if (document.readyState !== 'complete') window.addEventListener('load', measure, { once: true });
})();

/* R.A.F.E. :: BUY THE SET, on the PDP and in the cart drawer (block 12, item 3).
   The GBP 5 is enforced by two automatic BXGY discounts at checkout. Nothing here
   fakes a price: every figure shown is rendered by Liquid, this only chooses which
   of the already-rendered figures to display. */
(function () {
  'use strict';

  function addToCart(items, done, fail) {
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (b) { return { ok: r.ok, body: b }; });
    }).then(function (res) {
      if (!res.ok) { fail(res.body && res.body.description); return; }
      /* cart-items falls back to re-rendering its own section when the event
         carries no section html, which is exactly what we want here */
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: null, sourceId: 'rafe-set', data: { source: 'rafe-set' } }
      }));
      openDrawer();
      done(res.body);
    }).catch(function (e) { fail(e && e.message); });
  }

  function openDrawer() {
    setTimeout(function () {
      var cd = document.querySelector('cart-drawer-component');
      if (cd && typeof cd.open === 'function' && !cd.querySelector('dialog[open]')) {
        try { cd.open(); } catch (e) {}
      }
    }, 60);
  }

  /* ---- PDP widget ---- */
  function syncSet(root) {
    var rows = root.querySelectorAll('[data-rafe-set-row]');
    var cta = root.querySelector('[data-rafe-set-cta]');
    var was = root.querySelector('[data-rafe-set-was]');
    var now = root.querySelector('[data-rafe-set-now]');
    var sep = root.querySelector('.rafe-set__cta-sep');
    var label = root.querySelector('[data-rafe-set-label]');
    var note = root.querySelector('[data-rafe-set-note]');
    if (!cta) return;

    var checked = [], missing = 0, single = null;
    for (var i = 0; i < rows.length; i++) {
      var cb = rows[i].querySelector('[data-rafe-set-cb]');
      var sel = rows[i].querySelector('[data-rafe-set-size]');
      rows[i].classList.toggle('is-off', !(cb && cb.checked));
      if (!cb || !cb.checked) continue;
      checked.push(rows[i]);
      if (!sel || !sel.value) missing++;
      if (!single) single = rows[i];
    }

    var isSet = checked.length > 1;
    root.classList.toggle('is-set', isSet);

    if (isSet) {
      if (label) label.textContent = 'BUY THE SET';
      if (was) was.hidden = false;
      if (sep) sep.hidden = false;
      /* innerHTML throughout this sync: the price now contains a wrapped symbol, and
         textContent would strip the span on the first size change. */
      if (now) now.innerHTML = now.getAttribute('data-set') || now.innerHTML;
    } else {
      if (label) label.textContent = 'ADD TO CART';
      if (was) was.hidden = true;
      if (sep) sep.hidden = false;
      var cell = single ? single.querySelector('.rafe-set__price') : null;
      if (now && cell) now.innerHTML = cell.innerHTML.trim();
    }

    cta.disabled = missing > 0 || checked.length === 0;
    if (note) {
      if (checked.length === 0) note.textContent = 'SELECT AN ITEM';
      else if (missing > 1) note.textContent = 'SELECT BOTH SIZES';
      else if (missing === 1) note.textContent = 'SELECT A SIZE';
      else note.textContent = isSet ? 'SAVING APPLIED AT CHECKOUT' : '';
    }
  }

  function initSet(root) {
    /* same morph hazard as initPrompt below - guard on the node, not an attribute */
    if (root.rafeSetBound) return;
    root.rafeSetBound = true;
    root.setAttribute('data-rafe-set-ready', '');
    var now = root.querySelector('[data-rafe-set-now]');
    if (now) now.setAttribute('data-set', now.innerHTML.trim());

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-rafe-set-cb], [data-rafe-set-size]')) syncSet(root);
    });

    var cta = root.querySelector('[data-rafe-set-cta]');
    if (cta) cta.addEventListener('click', function () {
      var items = [];
      var rows = root.querySelectorAll('[data-rafe-set-row]');
      for (var i = 0; i < rows.length; i++) {
        var cb = rows[i].querySelector('[data-rafe-set-cb]');
        var sel = rows[i].querySelector('[data-rafe-set-size]');
        if (cb && cb.checked && sel && sel.value) items.push({ id: Number(sel.value), quantity: 1 });
      }
      if (!items.length) return;
      var live = root.querySelector('[data-rafe-set-live]');
      cta.disabled = true;
      cta.classList.add('is-busy');
      addToCart(items, function () {
        cta.classList.remove('is-busy');
        if (live) live.textContent = 'Added to cart.';
        syncSet(root);
      }, function (msg) {
        cta.classList.remove('is-busy');
        cta.disabled = false;
        if (live) live.textContent = msg || 'Could not add to cart.';
      });
    });

    syncSet(root);
  }

  /* ---- cart drawer prompt ---- */
  function initPrompt(root) {
    var sel = root.querySelector('[data-rafe-setprompt-size]');
    var btn = root.querySelector('[data-rafe-setprompt-add]');
    var live = root.querySelector('[data-rafe-setprompt-live]');
    if (!sel || !btn) return;

    /* The guard is a property on the NODE, not a data attribute.
       The cart drawer and the product form both re-render by MORPHING the DOM: the
       element survives with its listener still attached, but every attribute the new
       HTML does not carry is stripped off it - including a data-*-ready flag we set
       ourselves. The attribute guard therefore read false again after every cart
       update and bound a SECOND click handler to the same surviving button. Measured:
       one click on ADD TO SET fired two /cart/add.js calls and put the short in the
       cart twice. A JS property is invisible to the morph and dies with the node. */
    if (btn.rafeSetPromptBound) return;
    btn.rafeSetPromptBound = true;
    root.setAttribute('data-rafe-setprompt-ready', '');

    sel.addEventListener('change', function () { btn.disabled = !sel.value; });
    btn.addEventListener('click', function () {
      if (!sel.value) return;
      btn.disabled = true;
      addToCart([{ id: Number(sel.value), quantity: 1 }], function () {
        if (live) live.textContent = 'Added to cart.';
      }, function (msg) {
        btn.disabled = false;
        if (live) live.textContent = msg || 'Could not add to cart.';
      });
    });
  }

  function scan() {
    var a = document.querySelectorAll('[data-rafe-set]');
    for (var i = 0; i < a.length; i++) initSet(a[i]);
    var b = document.querySelectorAll('[data-rafe-setprompt]');
    for (var j = 0; j < b.length; j++) initPrompt(b[j]);
  }

  scan();
  document.addEventListener('cart:update', function () { setTimeout(scan, 120); });
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState !== 'complete') window.addEventListener('load', scan, { once: true });
})();


/* R.A.F.E. :: BACK control on the PDP (block 14, item 3).
   The markup is a real anchor to /collections/all so it works with JS off. When there
   is a same-origin history entry to return to we use history.back() instead, because
   that is what restores the scroll position in the grid - navigating to the collection
   URL afresh would land at the top. */
(function () {
  'use strict';

  function sameOrigin(url) {
    if (!url) return false;
    try { return new URL(url, location.href).origin === location.origin; }
    catch (e) { return false; }
  }

  function onClick(e) {
    var link = e.target.closest ? e.target.closest('[data-rafe-back]') : null;
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    /* history.length > 1 alone is not enough: a direct hit or an ad click can still
       report 2 because of the current entry. Require a same-origin referrer too. */
    var canGoBack = window.history.length > 1 && sameOrigin(document.referrer);
    if (!canGoBack) return; /* let the href do its job -> /collections/all */

    e.preventDefault();
    window.history.back();
  }

  document.addEventListener('click', onClick);
})();


/* R.A.F.E. :: free shipping progress, kept in sync after cart mutations (block 14,
   item 5). The snippet renders the correct state server side; this only handles the
   case where the drawer is re-rendered or a line is changed without a full reload, so
   the bar animates to its new width rather than jumping. */
(function () {
  'use strict';

  /* block 25, item 8: free UK shipping threshold, was 8500. Mirrors rafe_threshold in
     snippets/rafe-free-shipping.liquid - both must move together. */
  var THRESHOLD = 10000;

  /* block 25, item 6. This was the JS twin of money_without_trailing_zeros: the modulo
     test dropped '.00' on whole pounds, so the bar said £25 while the PDP said £25.00.
     Always two decimals now, and the symbol is wrapped so section 72 can balance it.
     Returns markup, so the caller writes innerHTML. minor is a number from /cart.js -
     there is no user input anywhere in this string. */
  function fmt(minor) {
    return '<span class="rafe-cur">\u00A3</span>' + (minor / 100).toFixed(2);
  }

  function paint(root, total) {
    if (!root) return;
    var pct = Math.min(100, Math.round((total * 100) / THRESHOLD));
    var remaining = THRESHOLD - total;
    root.style.setProperty('--rafe-ship-pct', pct + '%');
    root.classList.toggle('is-unlocked', remaining <= 0);
    root.classList.toggle('is-progress', remaining > 0);
    var track = root.querySelector('.rafe-ship__track');
    if (track) track.setAttribute('aria-valuenow', String(pct));
    var text = root.querySelector('[data-rafe-ship-text]');
    if (text) {
      /* innerHTML, not textContent: fmt() now returns a wrapped symbol. */
      text.innerHTML = remaining > 0
        ? fmt(remaining) + ' AWAY FROM FREE UK SHIPPING'
        : 'FREE UK SHIPPING UNLOCKED';
    }
    root.setAttribute('data-rafe-ship-total', String(total));
  }

  function sync() {
    var root = document.querySelector('[data-rafe-ship]');
    if (!root) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(root, c.total_price); })
      .catch(function () { /* leave the server-rendered state alone */ });
  }

  /* the fill needs a frame at its server-rendered width before it can transition */
  function prime() {
    var root = document.querySelector('[data-rafe-ship]');
    if (!root) return;
    var pct = root.style.getPropertyValue('--rafe-ship-pct');
    if (!pct) {
      var total = parseInt(root.getAttribute('data-rafe-ship-total') || '0', 10);
      requestAnimationFrame(function () { paint(root, total); });
    }
  }

  document.addEventListener('DOMContentLoaded', prime);
  document.addEventListener('cart:update', sync);
  document.addEventListener('cart:change', sync);
  document.addEventListener('cart:refresh', sync);

  var pending = null;
  var host = document.querySelector('cart-drawer-component') || document.body;
  if (host) {
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; prime(); }, 150);
    }).observe(host, { childList: true, subtree: true });
  }
})();


/* R.A.F.E. :: PDP gallery frame height (block 14, item 1).
   The gallery frames are sized to the window that is actually visible when the page
   is at rest, which is 100vh minus the document offset of the product grid
   (announcement bar + header + BACK control). Measuring it beats hardcoding, because
   the announcement bar can be switched off and the header height can change.
   Desktop pointer devices only - this mirrors the CSS media query, and on mobile the
   gallery is a swipe carousel that must not be touched. */
(function () {
  'use strict';

  var MQ = '(min-width: 990px) and (hover: hover) and (pointer: fine)';

  function apply() {
    var grid = document.querySelector('.product-information__grid');
    if (!grid) return;
    if (!window.matchMedia(MQ).matches) {
      grid.style.removeProperty('--rafe-pdp-rest');
      return;
    }
    var y = window.scrollY || window.pageYOffset || 0;
    var rest = Math.round(grid.getBoundingClientRect().top + y);
    if (rest > 0 && rest < window.innerHeight) {
      grid.style.setProperty('--rafe-pdp-rest', rest + 'px');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply, { passive: true });
  window.addEventListener('pageshow', apply);
})();


/* R.A.F.E. :: PDP pinned buy controls, measured offsets (block 16).
   The size row and ADD TO CART pin at staggered offsets inside the buy column. The
   second offset has to be the rendered height of the first pinned box, and the
   release margin has to be the rendered height of the button, so both are measured
   rather than hardcoded - a second row of size swatches would otherwise leave a gap
   or an overlap. CSS carries sane fallbacks (85px / 52px) if this never runs.
   Desktop pointer devices only, mirroring the media query in rafe-overrides.css. */
(function () {
  'use strict';

  var MQ = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  var ro = null;

  function pinnedSpan(pfb) {
    var btn = pfb.querySelector('[ref="addToCartButton"]');
    if (!btn) return null;
    var el = btn;
    while (el && el.parentElement !== pfb) el = el.parentElement;
    return el;
  }

  function apply() {
    var grid = document.querySelector('.product-information__grid');
    if (!grid) return;

    if (!window.matchMedia(MQ).matches) {
      grid.style.removeProperty('--rafe-buy-pin');
      grid.style.removeProperty('--rafe-atc-h');
      return;
    }

    var vp = grid.querySelector('.product-details variant-picker');
    var pfb = grid.querySelector('.product-details .product-form-buttons');
    var span = pfb ? pinnedSpan(pfb) : null;
    if (!vp || !span) return;

    var pin = Math.round(vp.getBoundingClientRect().height);
    var atc = Math.round(span.getBoundingClientRect().height);

    if (pin > 30 && pin < 300 && grid.style.getPropertyValue('--rafe-buy-pin') !== pin + 'px') {
      grid.style.setProperty('--rafe-buy-pin', pin + 'px');
    }
    if (atc > 20 && atc < 120 && grid.style.getPropertyValue('--rafe-atc-h') !== atc + 'px') {
      grid.style.setProperty('--rafe-atc-h', atc + 'px');
    }

    if (typeof ResizeObserver === 'function') {
      if (ro) ro.disconnect();
      ro = new ResizeObserver(function () { window.requestAnimationFrame(apply); });
      ro.observe(vp);
      ro.observe(span);
    }
  }

  function later() { window.requestAnimationFrame(apply); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply, { passive: true });
  window.addEventListener('pageshow', apply);
  document.addEventListener('variant:update', later);
  document.addEventListener('variantUpdate', later);
})();
